<template>
  <common-form @submit="$utils.navigate('/epworth')">
    <screener-frame>
      <screener-title
        title="Dental Sleep Solutions"
        hide-name
      />

      <p class="body-1">
        More than 20 million Americans suffer from
        Obstructive Sleep Apnea (OSA).
        Despite this high prevalence, 93% of women and 82% of men with
        moderate to severe OSA remain UNDIAGNOSED and UNAWARE that
        they have a deadly disease.
      </p>
      <p class="body-1">
        Please complete this short questionnaire to
        determine your risk of OSA.
        Your information is confidential and will only be shared with
        healthcare providers for diagnostic and treatment purposes.
      </p>

      <intro-form />

      <template #actions>
        <v-spacer />

        <v-btn
          class="button-next"
          color="primary"
          type="submit"
        >
          {{ $t("message['Proceed']") }}
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
      </template>
    </screener-frame>
  </common-form>
</template>

<script>
export default {
  name: 'Intro'
}
</script>
